import React from 'react'
import Linkton from '@components/linkton'
import * as styles from '../message-verification/MessageVerification.module.scss'

/**
 * Reusable banner for email verification and group limit errors.
 * Shares styles with the existing MessageVerification component.
 */
const VerificationErrorBanner = ({
  emailVerificationError,
  groupLimitError,
  verificationEmailSent,
  sendingVerificationEmail,
  handleResendVerificationEmail,
  verifyEmailMessage = 'Verify your email to continue',
  verifyEmailDescription = 'To help keep Soundation safe from spam, you need to verify your email address before performing this action.',
}) => {
  return (
    <>
      {emailVerificationError && (
        <div className={styles.errorContainer}>
          <div className={styles.errorTitle}>{verifyEmailMessage}</div>
          <div className={styles.errorDescription}>{verifyEmailDescription}</div>
          <div className={styles.errorActions}>
            {verificationEmailSent ? (
              <span className={styles.emailSentConfirmation}>Verification email sent!</span>
            ) : (
              <Linkton
                className={styles.resendButton}
                onClick={handleResendVerificationEmail}
                disabled={sendingVerificationEmail}
              >
                {sendingVerificationEmail ? 'Sending...' : 'Resend verification email'}
              </Linkton>
            )}
          </div>
        </div>
      )}
      {groupLimitError && (
        <div className={styles.errorContainer}>
          <div className={styles.errorTitle}>Group limit reached</div>
          <div className={styles.errorDescription}>
            You can create a maximum of 3 groups. Please delete an existing group before creating a new one.
          </div>
        </div>
      )}
    </>
  )
}

export default VerificationErrorBanner
